/* Collino TV — capa de datos compartida.
   Usada por sections/collino-tv-latest-home.liquid y sections/featured-blog.liquid
   (antes cada una duplicaba ~110 lineas de helpers y podian disparar el mismo
   fetch a Vimeo dos veces en la primera visita).
   Expone window.CollinoTV y dispara el evento 'collino-tv:ready'. */
(function () {
  if (window.CollinoTV) return;

  const CONFIG = {
    vimeoToken: "42779d06b7c017bbbbdbc04317cb9e18",
    season1Id: "11708520",
    season2Id: "11818063",
    // El prefijo sube a v3 junto con el cambio de cacheMs: las entradas ya
    // guardadas llevan grabado su propio `expires` a 12h, asi que bajar cacheMs
    // no las invalida. Sin cambiar la clave, el visitante que ya tiene cache
    // -justo al que le queremos mostrar el episodio nuevo- seguiria esperando
    // las 12h viejas. Cambiar el prefijo descarta las v2 de una.
    cachePrefix: "ctv_album_v3",
    // 1h. Antes 12h: demasiado para una seccion cuyo trabajo es mostrar lo
    // ultimo. Un episodio subido a la manana no le aparecia hasta la noche al
    // visitante que ya habia pasado, y la cinta lo anuncia como nuevo por 72h
    // (isVideoNew): el cache se peleaba con su propio proposito.
    cacheMs: 60 * 60 * 1000
  };

  const doFetch = async (albumId, perPage) => {
    const cacheKey = `${CONFIG.cachePrefix}_${albumId}`;
    try {
      const cached = JSON.parse(localStorage.getItem(cacheKey) || "null");
      if (cached?.expires > Date.now() && Array.isArray(cached.data)) {
        return cached.data;
      }
    } catch (err) {
      localStorage.removeItem(cacheKey);
    }

    const url = `https://api.vimeo.com/albums/${albumId}/videos?per_page=${perPage}&fields=uri,name,description,created_time,pictures.sizes,duration`;

    try {
      const res = await fetch(url, {
        headers: {
          "Authorization": `Bearer ${CONFIG.vimeoToken}`,
          "Accept": "application/vnd.vimeo.*+json;version=3.4"
        }
      });

      if (!res.ok) throw new Error(`Vimeo API error: ${res.status}`);
      const json = await res.json();
      const data = json.data || [];
      try {
        localStorage.setItem(cacheKey, JSON.stringify({
          expires: Date.now() + CONFIG.cacheMs,
          data
        }));
      } catch (err) {
      }
      return data;
    } catch (err) {
      console.error("Error fetching videos:", err);
      const failed = [];
      failed.failed = true;
      return failed;
    }
  };

  // Dedup de requests en vuelo: si dos secciones piden el mismo album a la
  // vez (primera visita, sin cache), comparten la misma promesa.
  const inflight = {};
  const fetchVideosFromAlbum = (albumId, perPage = 50) => {
    const key = `${albumId}:${perPage}`;
    if (!inflight[key]) {
      inflight[key] = doFetch(albumId, perPage).finally(() => { delete inflight[key]; });
    }
    return inflight[key];
  };

  const isVideoNew = (createdTime, isSeason2) => {
    if (!isSeason2) return false;
    const hoursDiff = (Date.now() - new Date(createdTime)) / (1000 * 60 * 60);
    return hoursDiff <= 72;
  };

  const escapeHtml = (str) =>
    String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  const formatDuration = (seconds) => {
    if (!seconds || isNaN(seconds)) return "";
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const pickBestThumb = (video, minWidth = 1280) => {
    if (!video?.pictures?.sizes?.length) return "";
    const sizes = video.pictures.sizes;
    const candidate = sizes.find(s => s.width >= minWidth) ||
                     sizes.find(s => s.width >= 640) ||
                     sizes[sizes.length - 1];
    return candidate?.link || "";
  };

  // fallback: 999 ordena los videos sin numero al final en orden descendente
  // (collino-tv-latest-home); featured-blog pasa 0 para mantener su criterio.
  const extractEpisodeNumber = (videoName, fallback = 999) => {
    const patterns = [
      /cap[ií]tulo\s*(\d+)/i,
      /episodio\s*(\d+)/i,
      /episode\s*(\d+)/i,
      /ep\.?\s*(\d+)/i,
      /e(\d+)/i,
      /#(\d+)/,
      /(\d+)/
    ];

    for (const pattern of patterns) {
      const match = String(videoName || '').match(pattern);
      if (match && match[1]) {
        return parseInt(match[1], 10);
      }
    }

    return fallback;
  };

  const extractEpisodeInfo = (name) => {
    const capMatch = name.match(/cap[ií]tulo\s*(\d+)/i);
    if (capMatch) return `Ep. ${capMatch[1]}`;

    const epMatch = name.match(/episodio\s*(\d+)/i);
    if (epMatch) return `Ep. ${epMatch[1]}`;

    const epShortMatch = name.match(/\bep\.?\s*(\d+)/i);
    if (epShortMatch) return `Ep. ${epShortMatch[1]}`;

    const hashMatch = name.match(/#(\d+)/);
    if (hashMatch) return `Ep. ${hashMatch[1]}`;

    return null;
  };

  window.CollinoTV = {
    CONFIG,
    fetchVideosFromAlbum,
    isVideoNew,
    escapeHtml,
    formatDuration,
    pickBestThumb,
    extractEpisodeNumber,
    extractEpisodeInfo
  };
  document.dispatchEvent(new CustomEvent('collino-tv:ready'));
})();
